// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6f19494b","952":"9c12a725"}[chunkId] + ".chunk.js";
};